export default "__VITE_ASSET__DdzkDRXZ__"